import styled from 'styled-components';

export default styled.div`
  .ant-steps-item-icon {
    display: none;
  }
  .seperator {
    margin-left: 10px;
    margin-right: 10px;
  }
  .order-status {
    display: flex;
    align-items: center;

    flex-wrap: wrap;
    .status-title {
      cursor: pointer;
      width: 100px;
      height: 100px;
      font-weight: 600;
      // padding: 10px;
      border: 2px solid;
      border-radius: 50%;
      font-size: 14px;
      margin-bottom: 10px;
      .title-content {
        border: 5px solid #fff;
        height: 100%;
        width: 100%;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: pre-wrap;
        line-height: normal;
        text-align: center;
        padding-left: 5px;
        padding-right: 5px;
        word-break: break-word;
      }
    }
  }
  .orderStatusImage {
    width: 300px;
    object-fit: contain;
  }
  // .ant-steps-item-finish {
  //   .ant-steps-item-title {
  //     color: ${({ theme }) => theme.palette.primary} !important;
  //   }
  //   svg {
  //     fill: ${({ theme }) => theme.palette.primary} !important;
  //   }
  // }
  // .ant-steps-item-error {
  //   .ant-steps-item-title {
  //     color: red !important;
  //     padding: 20px !important;
  //     border-radius: 50%;
  //     border: 1px solid #d9d9d9;
  //   }
  //   svg {
  //     fill: red !important;
  //   }
  // }
  // .ant-steps-item-custom {
  //   .ant-steps-item-title {
  //     font-size: 14px;
  //   }
  //  }
`;
